<template>
    <div class='adhibition'>

      <div :class="{'category-container':true,
      'md-and-down':menuHidden || (!menuHidden && md),
      'menu-nav-mini':!menuHidden && !md && navMini,
      'boxedWidth':boxedWidth,
      'transferHide':!isMove,'dark':$vuetify.theme.dark}" v-if="productData.length>0">
        <div class="category-container-box">
            <div class="scroll-container">
              <div class="scroll-container-content" ref="scrollId" :style="{'transform': 'translateY('+translateY+')'}">
                <div class="label-item" v-for="(item,index) in productData" :key="index" :id="item.value"  @mouseleave="mouseleaveCategory" @mouseover="mouseOverCategory">
                  <draggable
                    :force-fallback="true"
                    class="dropzone categoryzone" v-bind="trashOptions"
                    filter=".footer"
                    :dataAttr="item.value"
                    :id="item.value"
                    :data-id="item.value">
                    <div  class="footer"><img class="icons" :src="require('@/assets/img/app_icon/icon'+(index+1)+'.png')">{{item.text}}</div>
                  </draggable>
                </div>
              </div>

            </div>
            <div class="removeBtn" v-if="selectedProduct"  @mouseleave="mouseleaveCategory" @mouseover="mouseOverCategory">
              <draggable   class="dropzone trashzone" v-bind="trashOptions" dataAttr="data-id" data-id="1">
                <div slot="footer" class="footer"><img class="icons"  src="@/assets/img/remove.png">{{ $t("adhibition.removeApp")}}</div>
              </draggable>
            </div>
            <div class="buttonPage prevPage"  @mouseover="()=>scrollFun('up')" v-show="sumCount>0 && translateIndex > 0">
              <draggable
                :force-fallback="true"
                class="dropzone buttonzone" v-bind="trashOptions"
                 >
                <span></span>
              </draggable>
               </div>
            <div class="buttonPage nextPage" @mouseover="()=>scrollFun('down')" v-show="sumCount>0 && translateIndex < sumCount" >
              <draggable
                :force-fallback="true"
                class="dropzone buttonzone" v-bind="trashOptions"
              >
                <span></span>
              </draggable>
            </div>
        </div>
      </div>
		  <v-card class="h-full">
        <div class="sub-title" :class="$vuetify.theme.dark ? 'sub-title-d': 'sub-title-l'">
            <img src="@/assets/img/border.png" alt="">
            <span>{{$t("adhibition.title")}}</span>
        </div>
        <!-- <div class="box" v-if="listData.length != 0"> -->
        <v-container fluid>
          <v-row justify="space-between">
            <v-col
              cols="7"
              md="3" lg="2" xl="2" sm="4" xs="4" >
              <v-select
                v-model="selectedProduct"
                :items="productData"
                class="selectList select-box"
                solo
                outlined
                ref="selectOutlineBox"
                :label="allGroupName"
                dense
                :menu-props="{ bottom: true, offsetY: true }"
                hide-details="auto"
                @change="onSelectChange"
                @blur="onSelectBlur"
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    style="cursor: pointer;"
                    ripple
                    @mousedown.prevent
                  >
                    <v-list-item-icon @click="selectedAll" >
                      <!-- <v-icon v-text="icons.mdiApps"></v-icon> -->
                      <v-icon v-text="icons.mdiViewGridOutline" size="17" style="margin-top:3px;"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-title   @click="selectedAll">
                       {{allGroupName}}
                    </v-list-item-title>
                    <v-list-item-icon @click="editProductModel">
                      <v-icon v-text="icons.mdiPlus" style="color:#5066e0;">  </v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:item="{ item, index }">
                  <v-list-item style="padding:0 0 0 10px;">
                      <!-- <span class="pointColor" :style="{background: pointColor[findValueIndex(item.value)]}"></span> -->
                      <img class="pointColor" :src="pointColor[findValueIndex(item.value)]">
                      <v-list-item-title class="listItemTit" :title="item.text">
                      {{item.text}}
                      </v-list-item-title>
                  </v-list-item >
                  <v-divider class="mt-2"></v-divider>
                </template>
                <template v-slot:no-data>
                  <div class="no-data">{{ $t("adhibition.appGroup.noData") }}</div>
                </template>
              </v-select>
            </v-col>
             <v-col
                class="text-center"
                cols="5"
                md="3" lg="2" xl="2" sm="4" xs="4"
                v-if="selectedProduct"
              >
               <v-btn color="primary"  @click="updateGroupInfo" small>{{ $t("adhibition.appGroup.edit") }}</v-btn>
               <v-btn class="close_btn" @click="deleteGroup"  outlined  small>{{ $t("adhibition.appGroup.delete") }}</v-btn>
            </v-col>
          </v-row>
        </v-container>

        <!-- 应用列表 -->
        <div class="box">
            <div class="box-c">
              <draggable v-model="listData"
                         animation="500"
                         dragClass="dragClass"
                         ghostClass="ghostClass"
                         :force-fallback="true"
                         v-bind="drapOptions"
                         filter=".stopItem"
                         handle=".dropitem"
                         :delay= "5"
                         :move="onDragMove"
                         @end="onDragEnd"
                         @start="onDragStart"
                       style="display: flex;flex-wrap: wrap;"
              >
                <template   v-for="(item, index) in listData" :id="item.id"  >
                  <div style="position:relative;user-select: none; -webkit-user-drag: none;" class="stopItem" id="0" v-if="item.id == 0 && item.type=='app'" :key="index" >
                    <img  src="@/assets/img/add-apply.png" alt="" class="list1  logo-pic" :class="$vuetify.theme.dark ? '': 'list1-l'" :key="index" @click="applyApp" >
                    <span  :class="$vuetify.theme.dark ? 'text_overflow apply_app1': 'text_overflow  apply_app'" color="primary" dark="" aria-haspopup="true" aria-expanded="false" >{{ $t("adhibition.apply") }}</span>
                  </div>
                  <div class="dropitem" v-else>
                    <app :item="item" @rowFun="rowFun" />
                  </div>

                </template>
              </draggable>
            </div>
        </div>

      </v-card>


      <!-- start  添加修产品分类 dialog -->
        <v-dialog
            content-class="edit-pwd-box"
            v-model="visible"
            :visible="visible"
            persistent
            :width="drawWidth"
            v-if="visible"
            @cancel="handleCancel">
            <v-card>
                <div class="drawer-header d-flex align-center mb-4">
                    <span class="font-weight-semibold text-base text--primary">{{drawTitle}}</span>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        small
                        @click="handleCancel"
                        >
                        <v-icon size="30">
                            {{ icons.mdiClose }}
                        </v-icon>
                    </v-btn>
                </div>
                <v-card-text style="text-align:center;">
                  <component :is="currentComponent" @close="handleCancel" @success="success"
                            @initProductGroup="initProductGroup"
                            :selectedProduct="!selectedProduct ? null : selectedProduct"
                             :browser-keys = browserKeys
                             :componentData="componentData" ></component>

                </v-card-text>
            </v-card>
        </v-dialog>
      <!-- 删除产品分类 dialog -->
      <del-dialog :dialogDelete="dialogDelete" :dialogTitle="dialogTitle" @deleteItemConfirm="deleteItemConfirm" @close="dialogDelete=false"></del-dialog>

    </div>
</template>

<script>

import { accessList,
  reqGetAllProductGroup,
  reqAddProductGroup,
  reqGetProductGroupApps,
  reqUpdateGroupAppSort,
  reqUpdateGroupApp,
  reqDelGroup,
  reqCrossBrowserCommand
} from "@/api/index";
import { mdiViewGridOutline, mdiFolderSyncOutline,mdiPlus,mdiApps ,mdiTrashCan} from '@mdi/js'
import { mdiClose } from '@mdi/js'
import applyApp from './applyApp.vue'
import store from '@/store'
import draggable from 'vuedraggable';
import category from './category'
import app from './app'
import browserList from './browserList'
import {IsPC} from '@/utils/index'
import $vue from '@/main.js'

const PRESET_APP = {
    id:0,
    key:'1',
    type:'app',
    name:$vue.$t("adhibition.apply")

}



export default {

    components: { applyApp,draggable,category,app ,browserList},
    data() {
        return {
            productData:[],
            selectedProduct:'',
            valid: true,
            allGroupName:this.$t('adhibition.appGroup.whole'),
            currentComponent:'',
            componentData:null,
            dataList:null,
            drawTitle:'',
            drawWidth:800,
            translateY:0,
            translateIndex:0,
            sumCount:0,
            currentAppInfo:null,
            navMini:false,
            md:false,
            menuHidden:false,
            allGroupId:'',
            drapOptions:{
              group: 'appGroup',
              draggable: '.dropitem',

            },
           trashOptions: {
             group: {
              name: 'trash',
              draggable: '.dropitem',
              put: () => true,
              pull: false
            }
           },
            isMouseOverClass:false,
            isMouseoverTrash:false,
            isMove:false,
            boxedWidth:false,
            listData: [],
            itemData:[],
            browserKeys:[],
            visible: false,
            dialogDelete:false,
            dialogTitle:'',
            spinning: false,
            noData: false,
            modalWidth:500,
            confirmLoading: false,
            visibleMfa:false,
            ruleForm: {},
            multiFactor: [],
            appKey:'',
            isExitAllGroup:false,
            rules: {
                subusername: [
                    { required: true, message: this.$t('adhibition.subusernameMsg') }
                ],
            },
            layout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 14 },
            },
            nameList: [],
            rowData: {},
            icons: {
                mdiViewGridOutline,
                mdiFolderSyncOutline,
                mdiClose,
                mdiApps,
                mdiPlus,
                mdiTrashCan
            },
            pointColor:[
              // '#4A80F1', '#8AD4F1','#F1DC3C', '#8DE5A8','#F29551','#F37B78','#5BE4CE','#5CCFE5','#5CA0E5','#5C73E5','#735CE5','#A15CE5','#E55C73','#A1E55C','#5CE58A'
              require('@/assets/img/app_icon/icon1.png'),
              require('@/assets/img/app_icon/icon2.png'),
              require('@/assets/img/app_icon/icon3.png'),
              require('@/assets/img/app_icon/icon4.png'),
              require('@/assets/img/app_icon/icon5.png'),
              require('@/assets/img/app_icon/icon6.png'),
              require('@/assets/img/app_icon/icon7.png'),
              require('@/assets/img/app_icon/icon8.png'),
              require('@/assets/img/app_icon/icon9.png'),
              require('@/assets/img/app_icon/icon10.png'),
              require('@/assets/img/app_icon/icon11.png'),
              require('@/assets/img/app_icon/icon12.png'),
            ]
        };
    },
    created() {
        // this.getData()
        this.initProductGroup()


    },
    mounted() {
      // this.loadScorll()
    },

  watch: {
      '$vuetify.breakpoint.mdAndDown':{
        handler:function (val, oldVal) {
          this.md = val
        },
        immediate: true
      },
      '$store.state.appConfig.menu.isMenuHidden':{
        handler:function (val, oldVal) {
          this.menuHidden = val
        },
        immediate: true
      },
      '$store.state.appConfig.menu.isVerticalNavMini':{
        handler:function (val, oldVal) {
          this.navMini = val
        },
        immediate: true
      },

      '$store.state.appConfig.app.contentWidth':{
        handler:function (val, oldVal) {
          this.boxedWidth = val=="full"?false:true
          console.log('contentWidth: %s, contentWidth: %s', val, oldVal, this.contentWidth)
        },
        immediate: true
      },




},




    methods: {
    loadScorll(){
        this.translateY = 0
        this.translateIndex = 0
        this.sumCount = 0
        // this.$nextTick(()=>{
         if(this.productData.length>0){
           const clientHeight = this.$refs.scrollId.clientHeight
           console.log(clientHeight)
           if(clientHeight > 168 ){
              this.sumCount = Math.ceil(clientHeight/168) - 1;
            }
         }
       // })
    },

    scrollFun(type){
        if(this.sumCount > 0) {
            if(type == 'down' && this.translateIndex < this.sumCount) {
              this.translateIndex++;
              this.translateY = '-'+this.translateIndex*168+'px'
            }
          if(type == 'up' && this.translateIndex > 0) {
            this.translateIndex--;
            this.translateY = '-'+this.translateIndex*168+'px'
          }
        }
    },
        onSelectChange(e){
          this.selectedProduct = e
          this.reloadAppList(e)
       },
        onSelectBlur(e){


       },
       findValueIndex(value){
         let indexs = this.productData.findIndex(e => e.value == value)
         return indexs
       },
        getData() {
            this.spinning = true
            accessList().then(res=> {
                if (res.code == this.$GLOBA.StatusFound) {
                    this.$serverUrlFun().then(serverUrl=> {
                        var url = serverUrl+'/application/signOn/'+res.data
                        window.open(url, "_self");

                    })
                } else {
                  this.spinning = false
                  if (res.data) {
                    this.listData = [PRESET_APP, ...res.data]
                    this.itemData = [...res.data]
                  } else {
                    this.listData = [PRESET_APP]
                    this.itemData = []
                  }



                }
            })
        },
        //打开应用
        rowFun(e,val) {
            if(!IsPC()){
              window.open(val.loginUrl, "_blank");
              return
            }


            //主要兼容火狐问题
            if(e.target.className && e.target.className.indexOf('v-image v-responsive')> -1){
              return
            }
              this.currentAppInfo = val
              try{
                let browserList = JSON.parse(val.browser)
                if(browserList.length  == 1) {
                    if(browserList[0] == 0){
                      window.open(val.loginUrl, "_blank");
                    }else{
                      this.openBrowser(this.currentAppInfo.appKey,browserList[0])
                    }
                  }else{
                    this.drawWidth = 660
                    this.visible = true
                    this.drawTitle = this.$t("adhibition.appGroup.selectBrowser")
                    this.currentComponent = "browserList"
                    this.componentData = null
                    this.browserKeys = browserList
                  }

              }catch (e) {
                console.error(e)
              }

        },

        //在新浏览器打开
        openBrowser(appKey,browser) {
          reqCrossBrowserCommand({
            appKey:appKey,
            browser:browser
          }).then(res=>{
              if(res.code == 200) {
                window.location.href= res.data
              }
          })
        },

          //初始化组分类
        initProductGroup(){
          reqGetAllProductGroup().then(res=>{
            if(res.code == 200 && res.data) {
              let data = []
              for(let item of res.data) {
                  if(item.groupName == this.allGroupName) {
                    this.isExitAllGroup = true
                    this.allGroupId = item.id
                    continue;
                  }
                 data.push({
                   text:item.groupName,
                   value:item.id
                 })
              }

              if(this.selectedProduct){
                this.reloadAppList(this.selectedProduct)
              }else if(this.isExitAllGroup){
                 this.reloadAppList(this.allGroupId)
              }else{
                this.getData()
              }
              this.productData = data
              // this.loadScorll()
            }
          })
        },
        handleCancel() {
            this.visible = false
        },
        success(data){
          if(this.currentComponent == "category"){
              this.initProductGroup()
          }
          if(this.currentComponent == "browserList"){
            if(data){
              this.openBrowser(this.currentAppInfo.appKey,data.code)
            }
          }
          this.handleCancel()

        },
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.visible = false
                    this.$serverUrlFun().then(serverUrl=> {
                        var url = serverUrl+'/application/signOn/'+this.rowData.appKey+'/'+this.ruleForm.subusername;
                        window.open(url, "_blank");
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        applyApp(){
          this.drawWidth = 800
          this.visible = true
          this.drawTitle = this.$t("adhibition.apply")
          this.currentComponent = "applyApp"
        },
        selectedAll(){
          this.selectedProduct = ""
          this.$refs.selectOutlineBox.blur()
          if(this.isExitAllGroup) {
              this.reloadAppList(this.allGroupId)
          }else{
            this.getData()
          }

        },

        editProductModel(){
          this.$refs.selectOutlineBox.blur()
          this.drawWidth = 600
          this.visible = true
          this.drawTitle = this.$t("adhibition.appGroup.addGroup")
          this.currentComponent = "category"
          this.componentData = null
        },

        updateGroupInfo(){
          this.drawWidth = 600
          this.visible = true
          this.drawTitle = this.$t("adhibition.appGroup.editGroup")
          this.currentComponent = "category"

           let id = this.selectedProduct;

           let index =  this.productData.findIndex(e=>e.value == id)

            if(index > -1) {
                this.componentData = {
                  id:id,
                  groupName: this.productData[index].text
                }
            }
        },
      deleteGroup(){
        this.dialogTitle = this.$t("adhibition.appGroup.sureDeleteGroup")
        this.dialogDelete = true

      },
      deleteItemConfirm(){
        reqDelGroup({
          id: this.selectedProduct
        }).then(res=> {
          if(res.code == 200) {
            this.selectedProduct = ''
            store.dispatch('snackbar/openSnackbar',{
              snackbarText: res.message,
              colorType: 'success'
            })
          } else {
            store.dispatch('snackbar/openSnackbar',{
              snackbarText: res.message,
              colorType: 'error'
            })
          }
          this.initProductGroup()
        })
        this.dialogDelete = false

      },
      mouseleaveCategory(e){
        this.isMouseOverClass = true
      },
      mouseOverCategory(){
        this.isMouseOverClass = false
      },
    onDragMove(e){
      if(e.relatedContext.element == 0) {
        return false
      }
        return true
    },
      onDragStart(e){
        if(IsPC()){
          this.loadScorll()
          this.isMove = true

        }

        e.preventDefault()
      },
      onDragEnd(event) {

       let toClassNames = event.to.className
       let groupId = ""

        //如果存在全部分类,且选择了
        if(this.isExitAllGroup && !this.selectedProduct) {
          groupId = this.allGroupId
        }else{
          groupId = this.selectedProduct
        }

        //step 1 移动到分类里面

        if(toClassNames.indexOf('categoryzone') != -1) {
          //在这个区域说明时拖拽到分类里面了
          //如果从分类中移走了
            if(!this.isMouseOverClass) {
                reqUpdateGroupApp({
                  appId:this.itemData[event.oldIndex-1].id,
                  newId:event.to.id,
                  oldId:groupId
                }).then(res=>{
                    if(res.code == 200) {
                      this.alertModel('success',res.message)
                    }else{
                      this.alertModel('error',res.message)
                    }
                  this.reloadAppList(groupId)
                })
            }else{
                this.reloadAppList(groupId)
            }
        }else if(toClassNames.indexOf('trashzone') != -1){
          //移动到删除里面
          if(!this.isMouseOverClass) {
              let appIds = []
              for(let item of this.listData) {
                if(item.id != 0 && item.type != 'app') {
                  appIds.push(item.id)
                }
              }
              this.upSortApp(this.selectedProduct,appIds)
          }else{
              this.reloadAppList(groupId)
          }
        }else if (toClassNames.indexOf('buttonzone') == -1){
          let appIds = []
          for(let item of this.listData) {
            if(item.id != 0 && item.type != 'app') {
              appIds.push(item.id)
            }
          }
          //如果当前分类为空,说明是全部
          if((!this.selectedProduct)){
            if(this.isExitAllGroup){
              this.upSortApp(this.allGroupId,appIds)
            }else{
              //不存在全部组的时候
              reqAddProductGroup({
                type:0,
                groupName:this.allGroupName
              }).then(res=>{
                if(res.code == 200 && res.data){
                  //创建分类成功
                  this.isExitAllGroup = true
                  this.allGroupId = res.data
                  this.upSortApp(res.data,appIds)
                }
              })
            }
          }else{
            this.upSortApp(this.selectedProduct,appIds)

          }
        }
        this.isMove = false
      },
      reloadAppList(id){
          if(!id){
             this.getData()
             return
          }
        reqGetProductGroupApps({groupId:id}).then(res=>{
          if(res.code == 200 && res.data) {
            this.listData = [PRESET_APP,...res.data]
            this.itemData = [...res.data]
          }else{
            this.listData = [PRESET_APP]
            this.itemData = []
          }
        })
      },
      upSortApp(groupId,appIds){
          reqUpdateGroupAppSort({
            appIds:appIds.join(','),
            groupId:groupId
          }).then((res)=>{
              if(res.code == 200) {
                this.alertModel('success',res.message)
              }else{
                this.alertModel('error',res.message)
              }
              this.reloadAppList(groupId)
          })

      },
      alertModel(type,message){
        store.dispatch('snackbar/openSnackbar',{
          snackbarText: message,
          colorType:type
        })
      }

    },
}
</script>

<style lang='scss' scoped>
  .category-container {

    margin-right: 0.75rem;
    height: auto;
    opacity: 1;
    left:240px;
    position: fixed;
    right: 0;
    top:0%;
    margin-top: 60px;
    -webkit-transition: all .5s ease;
    -o-transition: all .5s ease;
    transition: all .5s ease;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: auto;
    z-index: 7;
    .category-container-box {
      background-color: #F6FAFE;
      border: 1px solid #E5E6EB;
      padding: 5px 180px 5px 10px;
      height: auto;
      position: relative;
      width: auto;
      .scroll-container {
        height: auto;
        max-height: 168px;
        min-height: 84px;
        overflow: hidden;

        .scroll-container-content {
          height:auto;
          overflow: auto;
          padding: 0 1px;
          -webkit-transition: all .2s ease;
          -o-transition: all .2s ease;
          transition: all .2s ease;
          width: 100%;
          .label-item{
            pointer-events: auto !important;
            color: #35383c;
            background: url("../../assets/img/drag_group_color_default.png");
            float: left;
            font-size: 16px;
            height: 64px;
            line-height: 64px;
            margin: 8px 0;
            position: relative;
            text-align: center;
            -webkit-transition: all .2s ease;
            -o-transition: all .2s ease;
            transition: all .2s ease;
            width: 166px;
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
            padding:0px 5px;

          }
          .label-item:hover {
            background: url("../../assets/img/drag_group_color_hove.png");
            color: #FFFFFF;
          }
        }
      }
    }
 }
  .md-and-down {
     left: 9px;
  }
  .menu-nav-mini {
    left: 79px;
  }
  /*.boxedWidth {*/
  /*  max-width: calc(1440px - (0.3rem * 2));*/
  /*  margin-right: auto !important;*/
  /*  margin-left: auto !important;*/
  /*  padding-right: 0.75rem;*/
  /*}*/

  .category-container.dark {
    .category-container-box {
      background: #3B355A;
    }
  }
  .removeBtn{
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-align-items: center;
    align-items: center;
    background: url("../../assets/img/drag_group_color_remove.png");
    bottom: 0;
    cursor: pointer;
    -js-display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
    position: absolute;
    right: 1.75rem;
    top: 0;
    margin-top: 13px;
    width: 166px;
    height: 64px;
    .trashzone  {
      height: 100%;
      width: 100%;
      .footer {
        text-align: center;
        line-height: 64px;
      }
    }
  }
  .removeBtn:hover{
    background: url("../../assets/img/drag_group_color_hove.png");
    color: #FFFFFF;
  }



    .buttonPage{
      background: #b0bccc;
      cursor: pointer;
      height: 20px;
      left: 50%;
      line-height: 15px;
      position: absolute;
      text-align: center;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translateX(-50%);
      -webkit-transition: all .2s ease;
      -o-transition: all .2s ease;
      transition: all .2s ease;
      width: 40px;

    }

  .prevPage {
    top: 0;
    border-radius: 0 0 20px 20px;
    transform: translateX(-50%);
    -webkit-transform-origin: top center;
    -ms-transform-origin: top center;
    transform-origin: top center;
    -webkit-transition: all .2s ease;
    -o-transition: all .2s ease;
    transition: all .2s ease;
    span{
      border-right: 1px solid #fff;
      border-top: 1px solid #fff;
      display: inline-block;
      height: 8px;
      -webkit-transform: rotate(-45deg);
      -ms-transform: rotate(-45deg);
      transform: rotate(-45deg);
      width: 8px;
    }
  }

.nextPage {

    border-radius: 0 0 20px 20px;
    border-radius: 20px 20px 0 0;
    top: auto;
    bottom: 0;
    -webkit-transform-origin: top center;
    -ms-transform-origin: top center;
    transform-origin: top center;
    -webkit-transform-origin: bottom center;
    -ms-transform-origin: bottom center;
    transform-origin: bottom center;
    span{
      border: 1px solid #fff;
      border-right: none;
      border-top: none;
      display: inline-block;
      height: 8px;
      -webkit-transform: rotate(-45deg);
      -ms-transform: rotate(-45deg);
      transform: rotate(-45deg);
      width: 8px;
    }
}
  .transferHide{
    opacity: 0;
    top: -100%;
  }


  .buttonzone .dropitem {
    display: none;
  }

  .categoryzone .dropitem {
    display: none;

  }

  .categoryzone {
    .footer {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 150px;
    }
  }


  .categoryzone .dropitem + .footer {
    /*background: red;*/
    /*color: white;*/

  }

  .trashzone .dropitem {
    display: none;
  }


  /*处理拖拽样式  */

  .ghostClass {
    opacity: 0 !important;
    visibility: hidden;

    cursor: move !important;
    .list {
      opacity: 0 !important;
      visibility: hidden;
      cursor: move !important;
    }
  }
  .dragClass {
    margin-left: 45px !important;
    margin-bottom: 20px !important;
    margin-top: 5px !important;
    cursor: move;
    .list{
      /*transform: scale(0.6);*/

      cursor: move;
      margin-left: 45px !important;
      margin-bottom: 0px !important;
      margin-top: 5px !important;
      width: 100px !important;
      height: 95px !important;

      .row-group {
        justify-content: start !important;
        .logo-pic{
          width: 48px !important;
          max-height:  48px !important;

        }

        .label {
          font-size: 12px !important;
        }

      }
    }


  }

.text-center {
  text-align: center;
}



.close_btn{
    margin-left: 10px;
  }

  .text-center {
    color: rgba(94, 86, 105, 0.68);
     .v-btn:not(.v-btn--round).v-size--small {
      padding: 0 4px;
      min-width: 51px;
      margin-top: 5px;
    }
  }
  .ant-tooltip-arrow {
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    left: 50%;

    bottom: -0.66412vw;
    position: absolute;
    display: block;
    width: 0.68078vw;
    height: 0.68078vw;
    overflow: hidden;
    background: transparent;
    pointer-events: none;
  }
  .ant-tooltip-arrow::before {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    width: 0.34042rem;
    height: 0.34042rem;
    margin: auto;
    background-color: rgba(0, 0, 0, 0.75);
    -webkit-box-shadow: 0.15625vw 0.15625vw 0.36458vw rgba(0, 0, 0, 0.07);
    box-shadow: 0.15625vw 0.15625vw 0.36458vw rgba(0, 0, 0, 0.07);
    -webkit-transform: translateY(-0.34039vw) rotate(45deg);
    transform: translateY(-0.34039vw) rotate(45deg);

    content: '';
    pointer-events: auto;

  }
  @media (max-width: 700px) {
    .ant-tooltip-arrow {
      overflow: hidden;
      bottom: -0.2102rem;
      width: 0.30042rem;
      height: 0.30042rem;

    }
    .ant-tooltip-arrow::before{
      width: 0.30042rem;
      height: 0.30042rem;
      background-color: rgba(0, 0, 0, 0.70);

    }

  }
  @media (max-width: 550px) {
    .ant-tooltip-arrow {
      bottom: -0.172rem;
      width: 0.30042rem;
      height: 0.2542rem;
      overflow: hidden;
    }
    .ant-tooltip-arrow::before{
      width: 0.30042rem;
      height: 0.30042rem;

    }
  }

.adhibition {
    // padding: 40px 70px;
    // margin-bottom: 32px;
    height: 100%;
    // background: #fff;
    border-radius: 10px;
    .sub-title {
        font-size: 18px;
        font-weight: 600;
        padding: 8px 0 8px 30px;
        display: flex;
        align-items: center;
        width: 100%;
        border-radius: 10px 10px 0 0;
        span {
            margin-left: 10px;
        }
    }
    .sub-title-l {
      background: #dce0f9;
      color: #333;
    }
    .sub-title-d {
      border-bottom: 1px solid #f0f0f0;
    }
    .title-dark {
      background: none;
      border-bottom: 1px solid #f0f0f0;
    }
    .title {
        padding-bottom: 30px;
    }
    .box-c {
        display: flex;
        flex-wrap: wrap;
    }
      .box-c>div, .select-box {
        margin-left: 8px;
      }
    .icons {
      padding: 5px 8px 8px 8px;
    }
    .box {
        // padding: 0 20px;
        flex: 1;
        overflow: auto;
        padding-bottom: 32px;
         .apply_app{
          position: absolute;
          // top: 60%;
          bottom: 50px;
          left: 0;
          color: #333333;
          text-align: center;
          // left: 37%;
          // width: 30%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .apply_app1{
          position: absolute;
          // top: 60%;
          bottom: 50px;
          left: 0;
          color: rgba(231, 227, 252, 0.68);
          text-align: center;
          // left: 37%;
          // width: 30%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .list1{
            margin-left: 15px;
            margin-right: 15px;
            margin-bottom: 25px;
            margin-top: 5px;
            width: 200px;
            height: 190px;
            cursor: pointer;
            position: relative;
        }
        .list1-l {
            background: #FFFFFF;
        }

            // .dash-box {
            //     position: absolute;
            //     top: 17px;
            //     right: 14px;
            //     display: none;
            //     .dash {
            //         font-size: 20px;
            //     }
            // }
        }
        .list-dark {
          background: #3B355A;
          box-shadow: 0 4px 8px -4px rgb(19 17 32 / 42%) !important;
        }
        // .list:hover {
        //     .dash-box {
        //         display: block;
        //     }
        // }
        // .list-add {
        //     border: 3px dashed #2E6BF7;
        //     border-radius: 12px;
        //     padding-top: 45px;
        // }

    .spin-box ::v-deep {
        height: 100%;
        .ant-spin-container {
            height: 100%;
            display: flex;
            flex-direction: column;
        }
    }
    .null-box {
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}
::v-deep .ant-modal-title::before{
    content: "";
    background-image: url(../../assets/img/border.png);
    // line-height: 29px;
    // margin-left: 16px;
    background-size: 100% 100%;
    width: 4px;
    position: absolute;
    top: 20px;
    left: 22px;
    height: 16px;

}
    ::v-deep .ant-modal-header{
        margin-left: 10px;

    }
    ::v-deep .ant-modal-title{
        font-weight: bold;
        font-size: 18px;
    }
    .text_overflow{
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
  .app-entrust-tip {
    position: absolute;
    bottom: -3px;
    right: -3px;
    z-index: 1;
    img {
      width: 36px;
      height: 36px;
    }
  }
  .drawer-header {
      border-bottom: 1px solid #f0f0f0;
  }

  ::v-deep .v-input__control {
    .v-input__slot {
      box-shadow:none !important;
    }
  }
  .no-data {
    font-size: 14px;
    padding: 10px 16px 3px;
  }
  .pointColor{
    margin-right: 10px;
  }
  .listItemTit{
    border-bottom:1px dashed #ccc;
    line-height: 40px !important;
    height: 40px;
  }
  ::v-deep{
    .v-list-item--link{
      height: 40px !important;
      line-height: 40px !important;
    }
  }
</style>
